import { syncLeitnerEvent } from './pilotSync.js';

export const LEITNER_INTERVALS = {
  young: [0, 1, 3, 7, 14],
  middle: [1, 3, 7, 14, 30],
  older: [1, 4, 10, 21, 45]
};

export function getAgeGroup(age) {
  if (age <= 5) return 'young';
  if (age <= 8) return 'middle';
  return 'older';
}

export function wordMasteryUpdate(mastery, word, correct, age, options = {}) {
  const m = {...mastery};
  const now = Date.now();
  const entry = m[word] ? {...m[word]} : { box: 1, lastSeen: now, exposures: 0, correct: 0 };
  const oldBox = entry.box;
  entry.exposures++;
  entry.lastSeen = now;
  if (correct) {
    entry.correct++;
    entry.box = Math.min(5, entry.box + 1);
  } else {
    entry.box = 1;
  }
  m[word] = entry;
  if (entry.box !== oldBox) {
    syncLeitnerEvent({
      childName: options.childName || null,
      sessionId: options.sessionId ?? null,
      word,
      correct,
      oldBox,
      newBox: entry.box
    }).catch(() => {});
  }
  return m;
}

export function isWordDue(entry, age) {
  if (!entry) return true;
  const group = getAgeGroup(age);
  const intervals = LEITNER_INTERVALS[group];
  const dayMs = 86400000;
  const interval = (intervals[entry.box - 1] || 0) * dayMs;
  return (Date.now() - entry.lastSeen) >= interval;
}

export function isWordMastered(entry) {
  if (!entry) return false;
  return entry.box >= 4 && entry.exposures >= 8 && (entry.correct / entry.exposures) >= 0.9;
}

export function getDueWords(wordMastery, age, limit) {
  const due = [];
  for (const [word, entry] of Object.entries(wordMastery || {})) {
    if (!isWordMastered(entry) && isWordDue(entry, age)) {
      due.push({ word, ...entry });
    }
  }
  due.sort((a, b) => {
    const as = a.source === 'school' ? 0 : 1;
    const bs = b.source === 'school' ? 0 : 1;
    return as - bs || a.box - b.box || a.lastSeen - b.lastSeen;
  });
  return due.slice(0, limit).map(d => d.word);
}

export function prioritizeWithLeitner(words, wordMastery, age) {
  if (!wordMastery || !words || words.length === 0) return words;
  const dueWords = getDueWords(wordMastery, age, 3);
  if (dueWords.length === 0) return words;
  const dueSet = new Set(dueWords);
  const dueItems = [];
  const rest = [];
  for (const w of words) {
    const wText = typeof w === 'string' ? w : w.word;
    if (dueSet.has(wText)) { dueItems.push(w); dueSet.delete(wText); }
    else rest.push(w);
  }
  return [...dueItems, ...rest];
}
